
<!-- Кадастровые объекты (объекты оценки) -->

<template>

<base_objects
	ref="base_objects"
	essence="ОО"
	:service="service"
	:single_element_url="single_element_url"
	with_status_filter
	with_group
	:without_edit_many="!check_roles([ 'grouping' ])"
	:keys_if_all_attrs_hidden="default_attrs"
>

	<!-- <template v-slot:many_edit_items>

		<sub_menu title="Расчеты" v-if="! only_info">

			<b-dropdown-item v-on:click="set_cost_many()" variant="primary">Расчет кадастровой стоимости</b-dropdown-item>

		</sub_menu>

	</template>-->

</base_objects>

</template>

<script>

import api from "../../../api"
import base_objects from "../base_objects"
// import sub_menu from "../../widgets/sub_menu"

export default
{
	components :
	{
		base_objects,
		// sub_menu,
	},

	data()
	{
		return {
			
			service : "cadastral_objects",
			single_element_url : "objects",

			is_parcel_group : false,
			is_oks_group : false,

		}
	},

	computed:
	{
		default_attrs()
		{
			const default_attrs = [
				"attrs.functional_sub_group",
				"attrs.ObjectType",
				"attrs.Area",
				"attrs.CadastralCost",
				"attrs.cost"
			]
			
			return api.has_oks()
				? ['attrs.CadastralNumber', "attrs.functional_group", ...default_attrs]
				: ['attrs.CadastralNumber', "attrs.Segment", "attrs.Evaluating_Using_Code", ...default_attrs]
		}
	},

	methods :
	{
		check_roles(roles)
		{
			return api.check_roles(this, roles)
		},

		set_cost_many()
		{
			const params =
			{
				query : this.$refs.base_objects.get_query(),
			}

			api.call_long_operation(this, "ОО / Множественное редактирование / Расчеты / Расчет кадастровой стоимости", "cadastral_objects", "set_cost_many", params, api.open_response_url)
		},
	}
}

</script>

